<template>
  <!-- Mission List Popup -->
  <div>
    <el-dialog
      title="Nhiệm vụ"
      :visible.sync="mainDialogVisible"
      :close-on-click-modal="false"
      width="900px"
    >
      <!-- <div class="das-form-container"> -->
      <div class="das-info-title">
        Thông tin đặt phòng {{ bookingInfo.booking_group_code }}
      </div>
      <hr />
      <InfoList :columns="3">
        <InfoListLabel>Tên khách</InfoListLabel>
        <InfoListValue>{{ bookingInfo.full_name }}</InfoListValue>

        <InfoListLabel>Ngày đến</InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_in_date)
        }}</InfoListValue>

        <InfoListLabel>Đoàn</InfoListLabel>
        <InfoListValue>{{ bookingInfo.booking_group_name }}</InfoListValue>

        <InfoListLabel>Số điện thoại</InfoListLabel>
        <InfoListValue>{{ bookingInfo.phone_number }}</InfoListValue>

        <InfoListLabel>Ngày đi </InfoListLabel>
        <InfoListValue>{{
          $displayDate(bookingInfo.check_out_date)
        }}</InfoListValue>

        <InfoListLabel>Công ty, đại lý du lịch</InfoListLabel>
        <InfoListValue>{{ bookingInfo.agent_name }}</InfoListValue>
      </InfoList>
      <div class="mt-10" style="height: 400px">
        <GridVx
          ref="missionListGrid"
          :columns="cols"
          dom-layout="scroll"
          :auto-select-first-row="false"
          :rows="rows"
          class="agGrid"
          @selectionChanged="onSelectionChange"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="mainDialogVisible = false"
          >
            Đóng
          </button>
          <!-- Messages -->
          <div class="flex gap-10">
            <button
              :disabled="
                rowsSelected.length === 0 || rowsSelected[0]?.cancel_user_id
              "
              class="btn primary small outline"
              @click="cancelMission()"
            >
              Hủy nhiệm vụ
            </button>
            <button
              v-if="checkAuthorMissionCancelComplete"
              class="btn primary small outline"
              :disabled="
                rowsSelected.length === 0 ||
                rowsSelected[0]?.status === 0 ||
                rowsSelected[0]?.cancel_user_id
              "
              @click="cancelCompleteMission"
            >
              Hủy hoàn thành
            </button>

            <button
              v-if="checkAuthorMissionComplete"
              :disabled="
                rowsSelected.length === 0 ||
                rowsSelected[0]?.status === 1 ||
                rowsSelected[0]?.cancel_user_id
              "
              class="btn primary small"
              @click="openCompleteMissionDialog()"
            >
              Hoàn thành
            </button>
            <button
              :disabled="
                rowsSelected.length === 0 || rowsSelected[0]?.cancel_user_id
              "
              class="btn primary small"
              @click="openEditDialog()"
            >
              Sửa
            </button>
            <button class="btn primary small" @click="openAddDialog()">
              Thêm
            </button>
          </div>
          <!-- <div class="flex gap-10">
            <button
              :disabled="rowsSelected.length === 0"
              class="btn primary small"
              @click="onSendMessage()"
            >
              Gửi
            </button>
            <button
              :disabled="rowsSelected.length === 0"
              class="btn primary small"
              @click="openCancelMessageDialog()"
            >
              Hủy
            </button>
            <button class="btn primary small" @click="openAddDialog()">
              Thêm
            </button>
          </div> -->
        </div>
      </span>
    </el-dialog>

    <el-dialog
      :title="isEdit ? 'Sửa nhiệm vụ' : 'Thêm nhiệm vụ'"
      :visible="addDialogVisible"
      :close-on-click-modal="false"
      width="700px"
      class="body-overflow__visible"
      @close="resetAddDialog"
    >
      <validation-observer ref="formValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <validation-provider rules="required" name="Bộ phận">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Bộ phận</span>
                    </div>
                    <el-select
                      v-model="submitForm.department_ids"
                      :disabled="isEdit"
                      placeholder=""
                      multiple
                      collapse-tags
                    >
                      <el-option
                        v-for="item in departmentOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-6">
                <div class="das-form-input">
                  <div class="label required">
                    <span>Ngày thực hiện</span>
                  </div>
                  <div>
                    <validation-provider
                      v-if="isEdit"
                      rules="required"
                      name="Ngày thực hiện"
                    >
                      <CalendarSelect
                        v-model="submitForm.impl_date"
                        mode="date"
                        :min-max="{
                          min: bookingInfo.arrive,
                          max: bookingInfo.depart
                        }"
                      />
                    </validation-provider>
                    <div v-else class="flex gap-10">
                      <validation-provider
                        style="flex: 1"
                        rules="required"
                        name="Ngày thực bắt đầu thực hiện"
                      >
                        <CalendarSelect
                          v-model="submitForm.start_date"
                          mode="date"
                          :min-max="{
                            min: bookingInfo.arrive,
                            max: bookingInfo.depart
                          }"
                        />
                      </validation-provider>
                      <validation-provider
                        style="flex: 1"
                        rules="required"
                        name="Ngày kết thúc thực hiện"
                      >
                        <CalendarSelect
                          v-model="submitForm.end_date"
                          mode="date"
                          :min-max="{
                            min: bookingInfo.arrive,
                            max: bookingInfo.depart
                          }"
                        />
                      </validation-provider>
                    </div>
                    <!-- <CalendarRange
                      v-else
                      v-model="datetimeRange"
                      mode="date"
                      :min-max="{
                        min: bookingInfo.arrive,
                        max: bookingInfo.depart
                      }"
                      @input="setDateRange"
                    /> -->
                    <!-- <template v-if="!isEdit">
                      <validation-provider
                        rules="required"
                        name="Ngày thực hiện"
                      >
                        <input v-show="false" v-model="submitForm.start_date" />
                      </validation-provider>
                      <validation-provider
                        rules="required"
                        name="Ngày thực hiện"
                      >
                        <input v-show="false" v-model="submitForm.end_date" />
                      </validation-provider>
                    </template> -->
                    <!-- <MultiCalendar
                      :from-date="submitForm.start_date"
                      :to-date="submitForm.end_date"
                      class="use-icon"
                      @changeDate="onChangeDate"
                    /> -->
                  </div>
                </div>
              </div>
              <div class="das-form-col col-6">
                <validation-provider
                  rules="required"
                  name="Thời gian thực hiện"
                >
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Thời gian thực hiện</span>
                    </div>
                    <validation-provider
                      rules="required"
                      name="Thời gian thực hiện"
                    >
                      <div class="flex gap-20">
                        <TimePicker
                          v-model="submitForm.exe_time"
                          format="HH:mm"
                        />
                      </div>
                    </validation-provider>
                  </div>
                </validation-provider>
              </div>
            </div>
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required" name="Nội dung">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Nội dung</span>
                    </div>
                    <textarea v-model="submitForm.content" :rows="3" />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addDialogVisible = false"
          >
            Đóng
          </button>
          <button v-if="isEdit" class="btn primary small" @click="onUpdate()">
            {{ $t('button.update') }}
          </button>
          <button v-else class="btn primary small" @click="onSubmitNew()">
            {{ $t('button.create') }}
          </button>
          <!-- <button class="btn primary small" @click="timePicker = {}"> -->
          <!-- tét -->
          <!-- </button> -->
        </div>
      </span>
    </el-dialog>
    <el-dialog
      title="Hoàn thành nhiệm vụ"
      :visible="addHandleDialog"
      :close-on-click-modal="false"
      width="600px"
    >
      <validation-observer ref="completeMissionFormValidator">
        <div class="das-form-container">
          <div class="das-form-group">
            <div class="das-form-row">
              <div class="das-form-col col-12">
                <validation-provider rules="required|max:200" name="Ghi chú">
                  <div class="das-form-input">
                    <div class="label required">
                      <span>Ghi chú</span>
                    </div>
                    <textarea
                      v-model="completeMissionSubmitForm.note"
                      :rows="3"
                    />
                  </div>
                </validation-provider>
              </div>
            </div>
          </div>
        </div>
      </validation-observer>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="addHandleDialog = false"
          >
            Hủy
          </button>
          <button class="btn primary small" @click="completeMission()">
            Thêm
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { checkAuthorized } from '@/utils/helper'
import {
  addForm,
  handleRow,
  getMissions,
  handleCancelRow,
  cancelCompleteMissionApi,
  cancelMissionApi,
  // eslint-disable-next-line no-unused-vars
  completeMissionApi
} from '@/api/cashier_service/postTransaction'
import { getDepartmentApi } from '@/api/userConfig/department'
import { updateMissionApi } from '@/api/booking_service/bookingGroup'
export default {
  data() {
    return {
      isEdit: false,
      // datetimeRange: {
      //   start: null,
      //   end: null
      // },
      // author
      checkAuthorMissionCancel: false,
      checkAuthorMissionCancelComplete: false,
      checkAuthorMissionComplete: false,
      //
      mainDialogVisible: false,
      addDialogVisible: false,
      rowsSelected: [],
      submitForm: {
        content: null,
        exe_time: '00:00',
        impl_date: null,
        sub_booking_group_id: null,
        start_date: null,
        end_date: null
      },
      cols: [
        {
          headerName: '#',
          field: 'no',
          width: 50
        },
        {
          headerName: 'Bộ phận',
          field: 'department_name',
          tooltipField: 'department_name',
          width: 200
        },
        {
          headerName: 'Trạng thái',
          field: 'status',
          valueGetter: param => {
            if (param?.data?.status === 1) {
              return 'Đã hoàn thành'
            } else if (param?.data?.status === 0) {
              return 'Chưa hoàn thành'
            } else if (param?.data?.status === 2) {
              return 'Đã hủy'
            } else {
              return null
            }
          }
          // width: 100
        },
        {
          headerName: 'Nội dung',
          field: 'content',
          tooltipField: 'content',
          width: 200
        },
        {
          headerName: 'Thời gian thực hiện',
          field: 'exe_time',
          width: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.exe_time) || null
          }
        },
        {
          headerName: 'Người thực hiện',
          field: 'implement_name',
          tooltipField: 'implementer',
          width: 150
        },
        {
          headerName: 'Thời gian hoàn thành',
          field: 'completion_time',
          width: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.completion_time) || null
          }
        },
        {
          headerName: 'Người tạo',
          field: 'create_user_name',
          tooltipField: 'create_user_name',
          width: 150
        },
        {
          headerName: 'Thời gian tạo',
          field: 'create_date',
          width: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.create_date) || null
          }
        },
        {
          headerName: 'Người hủy',
          field: 'cancel_user_name',
          tooltipField: 'cancel_user_name',
          width: 150
        },
        {
          headerName: 'Thời gian hủy',
          field: 'cancel_time',
          width: 200,
          valueGetter: params => {
            return this.$displayDate(params?.data?.cancel_time) || null
          }
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note'
        }
      ],
      rows: [],
      // ***************************************
      departmentOptions: [],
      addHandleDialog: false,
      completeMissionSubmitForm: {
        note: null
      }
    }
  },
  computed: {
    bookingInfo() {
      return this.$store.getters['cashier']
    }
  },
  watch: {
    datetimeRange() {},
    timePicker() {},
    addHandleDialog() {
      this.addHandleDialog
        ? null
        : this.$nullValueInObj(this.completeMissionSubmitForm)
    }
  },
  mounted() {
    this.checkAuthorMissionCancel = checkAuthorized('MISSION_CANCEL')
    this.checkAuthorMissionCancelComplete = checkAuthorized(
      'MISSION_CANCEL_COMPLETE'
    )
    this.checkAuthorMissionComplete = checkAuthorized('MISSION_COMPLETE')
  },
  methods: {
    async cancelMission() {
      await cancelMissionApi(this.rowsSelected[0].id)
        .then(async res => {
          const message = res.message
          this.addDialogVisible = false
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    openEditDialog() {
      this.isEdit = true
      // fill data to edit Form
      this.submitForm.id = this.rowsSelected[0].id
      this.submitForm.impl_date = this.$moment(
        this.rowsSelected[0].exe_time
      ).format('YYYY-MM-DD')
      this.submitForm.exe_time = this.$moment(
        this.rowsSelected[0].exe_time
      ).format('HH:mm')
      this.submitForm.content = this.rowsSelected[0].content
      this.submitForm.department_ids = [this.rowsSelected[0].department_id]
      //
      this.addDialogVisible = true
    },
    async onUpdate() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      await updateMissionApi(this.submitForm.id, this.submitForm)
        .then(async res => {
          const message = res.message
          this.addDialogVisible = false
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async onSubmitNew() {
      if ((await this.$vxForm.isValid(this.$refs.formValidator)) === false) {
        return
      }
      const url = '/booking-service/v1/missions/insert'
      this.submitForm.sub_booking_group_id = this.bookingInfo.id
      await addForm(url, this.submitForm)
        .then(async res => {
          const message = res.message
          this.addDialogVisible = false
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async attachData() {
      const data = await getMissions({
        subBookingGroupId: this.bookingInfo.id
      })
      this.rows = data.data || []
      this.rowsSelected = []
    },
    async getInitData() {
      await this.getDepartmentOptions()
      await this.attachData()
      this.mainDialogVisible = true
    },
    openAddDialog() {
      this.addDialogVisible = true
    },
    resetAddDialog() {
      this.$nullValueInObj(this.submitForm)
      this.submitForm.exe_time = '00:00'
      // this.datetimeRange = {
      //   start: null,
      //   end: null
      // }
      this.isEdit = false
      // this.submitForm.sub_booking_group_id = this.bookingInfo.id
    },
    onSelectionChange(rows) {
      this.rowsSelected = rows
    },
    // *********************************
    async openCompleteMissionDialog() {
      this.addHandleDialog = true
    },
    async completeMission() {
      if (
        (await this.$vxForm.isValid(
          this.$refs.completeMissionFormValidator
        )) === false
      ) {
        return
      }
      const id = this.rowsSelected[0].id
      await completeMissionApi(id, this.completeMissionSubmitForm.note)
        .then(async res => {
          this.addHandleDialog = false
          const message = res.message
          this.attachData()
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async cancelCompleteMission() {
      const id = this.rowsSelected[0].id
      await cancelCompleteMissionApi(id)
        .then(async res => {
          const message = res.message
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
          this.attachData()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    // changeTime(time) {
    // this.submitForm.exe_time = time.displayTime
    // },
    async getDepartmentOptions() {
      const data = await getDepartmentApi()
      this.departmentOptions = data.data || []
    },
    openHandleRowDialog() {
      this.addHandleDialog = true
    },
    async cancelHandleRow() {
      const id = this.rowsSelected[0].id
      await handleCancelRow(`/cashier-service/v1/room-comment/${id}/cancel`)
        .then(async res => {
          const message = res.message
          this.addHandleDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    async submitHandleForm() {
      const id = this.rowsSelected[0].id
      const url = `/cashier-service/v1/room-comment/${id}/handle`
      await handleRow(url, this.completeMissionSubmitForm)
        .then(async res => {
          const message = res.message
          this.addHandleDialog = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    }
  }
}
</script>
